export default __webpack_public_path__ + "media/images/images/gallery/20-ac92e10ac4b36d55b4aacf07f40ebb06.jpg";